module.exports = __webpack_public_path__ + "img/slide-17-4.0cc666b7.png";